// Angular
import { Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
// Local services
import { ClienteService } from '../../services/cliente.service';
import { CommonUtilitiesService } from '../../services/common-utilities.service';
// 3rd libraries
import swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { kill } from 'process';
import * as moment from "moment";

@Component({
  selector: 'app-gestiones-alertas',
  templateUrl: './gestiones-alertas.component.html',
  styleUrls: ['./gestiones-alertas.component.scss']
})
export class GestionesAlertasComponent implements OnInit {
  // tipoAlerta = 'verde'
  // tipoAlerta = 'rojo'
  tipoAlerta = 'None';
  isCollapseDebtor = true;
  isCollapseCoDebtor = true;
  showContent = false;
  @Input() clienteserviceParam: ClienteService;
  @Output() selecttab = new EventEmitter<number>();
  @Output() refreshPrecalificaciones = new EventEmitter<boolean>();
  constructor(
    private ngxUiLoaderService: NgxUiLoaderService,
    private utilitiesService: CommonUtilitiesService,
    public router: Router,
    ) {
      this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
      setTimeout(() => {
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
        this.tipoAlerta = this.clienteserviceParam.reglaRechazo === 'R'
          ? 'rojo' : this.clienteserviceParam.reglaRechazo === 'A'
            ? 'amarillo' : 'verde';
        this.showContent = true;
    }, 2000);
  }

  ngOnInit(): void {
  }

  async goToOferta() {
    let datapreca={
      noPrecalificacion:this.clienteserviceParam.ofertasComerciales.numeroPrecalificacion,
      usuarioAbf: localStorage.getItem('nickUser').toUpperCase(),
      fechaRegistro: moment(new Date()).format('DD/MM/YYYY'),
      nombreCompleto:this.clienteserviceParam.datosCliente.cliente.nombreCompleto,
      tipoProducto: this.clienteserviceParam.tipoPrecalificacion
    }
    let resultadoPreca=this.clienteserviceParam.reglaRechazo === 'R'
            ? 'RECHAZADO' : this.clienteserviceParam.reglaRechazo === 'A'
              ? 'EN REVISIÓN' : 'PREAPROBADO'
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    if (this.clienteserviceParam.reglaRechazo == 'R') {
      this.clienteserviceParam.guardarCreditoRojo().then(result => {
          if(this.clienteserviceParam.rolABFlag){
            this.clienteserviceParam.sendEmailDetalleAB(resultadoPreca,datapreca)
            this.clienteserviceParam.sendSmsAB(datapreca,this.clienteserviceParam.datosPrecalificacion.celular,resultadoPreca) 
          }
          this.selecttab.emit(0);
          this.utilitiesService.refreshPrecalificationData(true);
      }).catch(error => {
        if (error === 'errorguardado') {
          this.showNotification('Ha ocurrido un error', 'No se ha podido guardar la precalificación.');
        } else {
          this.showNotification('Ha ocurrido un error', 'Por favor inténtelo mas tarde.');
        }
      })
    } else {
      this.clienteserviceParam.guardarCredito().then(result => {
        if(this.clienteserviceParam.rolABFlag){
          this.clienteserviceParam.sendEmailDetalleAB(resultadoPreca,datapreca)
          this.clienteserviceParam.sendSmsAB(datapreca,this.clienteserviceParam.datosPrecalificacion.celular,resultadoPreca) 
        }
        this.selecttab.emit(0);
        this.utilitiesService.refreshPrecalificationData(true);
      }).catch (error=> {
        if (error === 'errorguardado') {
          this.showNotification('Ha ocurrido un error', 'No se ha podido guardar la precalificación.');
        } else {
          this.showNotification('Ha ocurrido un error', 'Por favor inténtelo mas tarde.');
        }
        })
    }
  }

  goToConsolidacion() {
    if (this.clienteserviceParam.tipoPrecalificacion == 'credito_fiduciario') {
      this.clienteserviceParam.ofertaseleccionada = null
      this.clienteserviceParam.commonCredits = []
      this.clienteserviceParam.mixAndMachMontoAhorro=0
      if(this.clienteserviceParam.rolABFlag){
        this.selecttab.emit(20); 
      }else{
        this.selecttab.emit(10); 
      }
    } else if (this.clienteserviceParam.tipoPrecalificacion == 'tarjeta_credito') {
      if (this.clienteserviceParam.reglaRechazo == 'R') {
        this.clienteserviceParam.listReglaRechazo=[]
      }
      this.selecttab.emit(18)
    }
  }
  showNotification(title, message) {
    swal.fire({
      title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {});
  }
}
